import type { PaginatedResponse } from '@/types'

export type TaxRegime = 'none' | 'russian_npd_4' | 'russian_npd_6' | 'usn_6' | 'usn_15' | 'custom'
export type ExpenseCategory = 'rent' | 'marketing' | 'tools' | 'other'
export type IncomeGroupBy = 'day' | 'week' | 'month'
export type IncomeBreakdown = 'student' | 'group' | 'subscription' | 'method'

export interface TaxSettings {
  id: number | null
  teacher_id: number
  regime: TaxRegime
  custom_rate: string | null
  effective_rate: string
  currency: string
  created_at: string | null
  updated_at: string | null
}

export interface TaxSettingsInput {
  regime: TaxRegime
  custom_rate?: number | null
  currency?: string
}

export interface Expense {
  id: number
  teacher_id: number
  date: string
  category: ExpenseCategory
  amount: string
  currency: string
  description: string | null
  attachments: string[] | null
  created_at: string | null
  updated_at: string | null
}

export interface ExpenseInput {
  date: string
  category: ExpenseCategory
  amount: number
  currency?: string
  description?: string | null
}

export interface ExpenseFilters {
  category?: ExpenseCategory
  from?: string
  to?: string
  page?: number
  per_page?: number
}

export type ExpensesPage = PaginatedResponse<Expense>

export interface IncomeReportParams {
  from?: string
  to?: string
  group_by?: IncomeGroupBy
  breakdown?: IncomeBreakdown
}

export interface IncomeSeriesPoint {
  period: string
  gross: string
}

export interface IncomeBreakdownRow {
  key: string
  label: string
  gross: string
}

export interface IncomeReport {
  from: string
  to: string
  group_by: IncomeGroupBy
  breakdown: IncomeBreakdown | null
  currency: string
  totals: { gross: string }
  series: IncomeSeriesPoint[]
  breakdown_rows: IncomeBreakdownRow[]
}

export interface ExpenseByCategory {
  category: ExpenseCategory
  amount: string
}

export interface AccountingSummary {
  from: string
  to: string
  currency: string
  regime: TaxRegime
  tax_rate: string
  gross: string
  tax: string
  expenses: string
  net: string
  expenses_by_category: ExpenseByCategory[]
}

export const TAX_REGIMES: TaxRegime[] = [
  'none',
  'russian_npd_4',
  'russian_npd_6',
  'usn_6',
  'usn_15',
  'custom',
]

export const EXPENSE_CATEGORIES: ExpenseCategory[] = ['rent', 'marketing', 'tools', 'other']
